import styled from "styled-components";

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 0;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;
  
  border-bottom: 1px solid #e5e5e5;
`;